import React from 'react'
import { BRadio } from '@prague-digi/ui-components'
import { Field } from 'redux-form'

import { fieldAdapter, FieldProps } from '../../utils/field'

interface Props {
  name: string
  testid: string
  message?: any
  option: any
  onClick?: () => void
  theme: any
}

const RadioButton = (props: Props & FieldProps) => (
  <BRadio {...props} value={props.option} checked={props.value === props.option} />
)

export const renderRadioButton = fieldAdapter(RadioButton)

export const RadioButtonField = (props: Props) => <Field {...props} component={renderRadioButton} />

export default RadioButtonField
